const searchModal = document.querySelector('#search-modal');

if (searchModal) {
  const enhanceSearch = () => {
    const form = searchModal.querySelector('form[role="search"]');
    const input = searchModal.querySelector('input[type="search"]');
    const results = searchModal.querySelector('#predictive-search-results');

    if (form && !form.querySelector('input[name="type"]')) {
      const resourceType = document.createElement('input');
      resourceType.type = 'hidden';
      resourceType.name = 'type';
      resourceType.value = 'product';
      form.append(resourceType);
    }

    if (input) {
      for (const attribute of [
        'role',
        'aria-expanded',
        'aria-owns',
        'aria-controls',
        'aria-haspopup',
        'aria-autocomplete',
      ]) {
        input.removeAttribute(attribute);
      }
    }

    results?.removeAttribute('role');
  };

  new MutationObserver(enhanceSearch).observe(searchModal, { childList: true, subtree: true });
  enhanceSearch();

  document.addEventListener(
    'keydown',
    (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('#search-modal')) return;

      if (event.key === 'Tab') {
        const focusableElements = [...searchModal.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])')]
          .filter((element) => !element.hidden && !element.hasAttribute('disabled') && element.getClientRects().length > 0);
        const currentIndex = focusableElements.indexOf(document.activeElement);
        const nextIndex = event.shiftKey
          ? (currentIndex - 1 + focusableElements.length) % focusableElements.length
          : (currentIndex + 1) % focusableElements.length;

        event.preventDefault();
        event.stopImmediatePropagation();
        focusableElements[nextIndex]?.focus();
        return;
      }

      if (event.key !== 'Enter' || !event.target.matches('input[type="search"]')) return;

      const selectedResult = searchModal.querySelector('[aria-selected="true"]');
      if (selectedResult) return;

      const form = event.target.closest('form');
      if (!(form instanceof HTMLFormElement)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const searchUrl = new URL(form.action, window.location.origin);
      searchUrl.searchParams.set('q', event.target.value);
      searchUrl.searchParams.set('type', 'product');
      window.location.assign(searchUrl);
    },
    true
  );
}

const header = document.querySelector('#header-component');

if (header) {
  const enhanceHeader = () => {
    for (const item of header.querySelectorAll('overflow-list li[role="presentation"]')) {
      item.removeAttribute('role');
    }

    header.querySelector('overflow-list button[role="menuitem"]')?.removeAttribute('role');
  };

  new MutationObserver(enhanceHeader).observe(header, {
    attributes: true,
    attributeFilter: ['role'],
    childList: true,
    subtree: true,
  });
  enhanceHeader();
}

let previewFrameChecks = 0;
const previewFrameTimer = window.setInterval(() => {
  const previewFrame = document.querySelector('#PBarNextFrame');

  for (const facets of document.querySelectorAll('.facets__overflow-list')) {
    facets.shadowRoot?.querySelector('ul[part="list"]')?.setAttribute('role', 'presentation');
  }

  if (previewFrame) {
    previewFrame.title = 'Barra de vista previa de Shopify';
  }

  if (previewFrameChecks >= 20) {
    window.clearInterval(previewFrameTimer);
  }

  previewFrameChecks += 1;
}, 500);
